import { ProcessorService } from '@df/ng/processor.service';

/**
 * Property decorator letting you inject angular injectables without constructor
 *
 * @deprecated Use angular's `inject()` instead
 *
 * ## Usage
 * ```typescript
 * class SomeClass {
 *     @NgInject(SomeService)
 *     someService : SomeService
 * }
 * ```
 *
 * @author Maurycy Ornat maurycy@tomandco.co.uk
 * @param  {any} token [description]
 */
export function NgInject(token: any) {
    return function (target: any, key: string) {
        let injected;
        ProcessorService.injectorSubject.subscribe(() => {
            if (injected) {
                injected = undefined;
            }
        });

        Object.defineProperty(target, key, {
            get: () => {
                if (!injected) {
                    try {
                        injected = ProcessorService.injector.get(token);
                    } catch (err) {
                        console.log(err);
                    }
                }
                return injected;
            }
        });
    };
}
